package br.com.htms.inspeccaocampo.data

/**
 * Catálogo de obras (form dropdown). Seed embutido = fallback se a API falhar.
 * Lista canônica no servidor (D1); admin ativa/desativa e adiciona itens.
 */
data class ObraItem(
    val id: String,
    val nome: String,
    val ativo: Boolean = true,
    val sortOrder: Int = 0
)

object ObraCatalog {
    /** Nomes iniciais (todos ativos). Ordem = sort_order no seed. */
    val SEED_NOMES: List<String> = listOf(
        "2000 - ADMINISTRATIVO-ENERGIA",
        "2001 - ALMOX-ENERGIA",
        "2002 - ALOCAÇÃO COMPARTILHADA",
        "2020 - COMERCIAL ENERGIA",
        "2099 - CONSÓRCIO TAPA",
        "3001 - LT BERNECK",
        "3002 - SE AREIA - ELETROSUL - ENERGIA",
        "3003 - SE CURITIBA - ELETROSUL - ENERGIA",
        "3004 - LDAT 138 kV BARBOSA FERRAZ - IVAIPORÃ - COPEL DIS.",
        "3005 - TUCUMANN/ATOM - RELOCAÇÃO 109 - COPEL DIS.",
        "3006 - Secc da LDAT 138kV Porto / Paranaguá na SE APPA e SE 138kV APPA",
        "3007 - SE JOINVILLE SUL - NEO",
        "3008 - SE CAMPOS NOVOS 525 kV - ENERGIA",
        "3009 - SE SALTO SANTIAGO - ENERGIA",
        "3010 - SE GUARAPUAVA (SE GVA) - COPEL DIS",
        "3011 - SE CURITIBA - AMP. N",
        "3012 - LDAT 138kV ARE.PAS/ARE.FOS",
        "3013 - SE CASCAVEL NORTE (Banco de Capacitores 138 kV - 30 MVAR)",
        "3014 - SE CASCAVEL NORTE (3º Autotransformador 230/138 kV de 150 MVA)",
        "3015 - ATOM - SECCIONAMENTO PARANAGUÁ na SE APPA",
        "3016 - AXIA - Subestação Passo Fundo - SE PFU",
        "3017 - AXIA - Subestação Xanxerê - SE XAN",
        "3018 - COPEL - Reconstrução Emergencial LDAT Cascavel",
        "3019 - PROJ TRANS RQL (FD)",
        "3020 - LTDA 138kV - COPEL DIS 01",
        "3021 - PROJ TRANS RQL (HTMS)",
        "3022 - Recomposição estrutural de LDATs 138kV",
        "3023 - EMERGENCIA IVAIPORÃ 12.09.26"
    )

    fun seedAtivas(): List<ObraItem> =
        SEED_NOMES.mapIndexed { i, nome ->
            ObraItem(id = "seed_$i", nome = nome, ativo = true, sortOrder = i)
        }
}
